import React, { useEffect, useState } from "react";
import "./Enquiry_Form_Modal.css";
import { Accordion, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Submit_Btn from "../../common_btn/submit_btn/Submit_Btn";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { getCities, getCourses, getCourseWiseSpecializations, getStates, postEnquiryForm } from "../../../../utils/apis/enquiry_form/Enquiry_Form";
import { Select2Data } from "../../../../utils/common";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "js-cookie";
import Common_Form from "../../common_form/Common_Form";

function Enquiry_Form_Modal({ baseLink, ...props }) {
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const coursesdata = [
        { id: "lykam_matte", name: "BBA" },
        { id: "glossy_paper", name: "BCA" },
        { id: "premium_card", name: "Diploma" },
    ];

    const navigate = useNavigate();

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    const [statesData, setStatesData] = useState([]);
    const [cities, setCities] = useState([]);
    const [courses, setCourses] = useState([]);
    const [specilization, setSpecilization] = useState([]);





    const GetAllCities = async (id) => {
        const response = await getCities(id);

        if (response?.success) {
            setCities(await Select2Data(response?.data, "city_id"));
        }
    };

    const GetAllSpecilization = async (id) => {
        const response = await getCourseWiseSpecializations(id);

        if (response?.success) {
            setSpecilization(await Select2Data(response?.data, "specilization_id"));
        }
    };


    useEffect(() => {

        const GetAllStates = async (id) => {
            const response = await getStates(1);

            if (response?.success) {
                setStatesData(await Select2Data(response?.data, "state_id"));
            }
        };

        GetAllStates();

        const getAllCourses = async (id) => {
            // id for profcyma 
            const response = await getCourses(6);

            // id for Subdomain 
            // const response = await getCourses(1);

            if (response?.success) {
                setCourses(await Select2Data(response?.data, "state_id"));
            }
        };

        getAllCourses();


    }, []);

    const onSubmit = async (data) => {

        const formData = new FormData();

        formData.append("name", data?.name);
        formData.append("email", data?.email);
        formData.append("mobile", data?.contact_no);
        formData.append("state_id", data?.state_id?.value ?? null);
        formData.append("district_id", data?.city_id?.value ?? null);
        formData.append("course_id", data?.course_id?.value ?? null);
        formData.append("specilization_id", data?.specilization_id?.value ?? null);

        // source name
        // formData.append("source_name", "Google_LP");

        // profcyma domain and  api key
        // formData.append("api_key", "profcyma-website");

        // profcyma 46 domain source_name and  api key
        // formData.append("source_name", "Profcyma_Google");
        // formData.append("api_key", "profcyma-new-website");


        // profcyma masterdegreecourses domain source_name and  api key
        // formData.append("source_name", "Profcyma_Google_MBA-WX");
        // formData.append("api_key", "Profcyma_Google_MBA-WX");


        // profcyma onlinemasterdegrees domain source_name and  api key
        formData.append("source_name", "Profcyma_Google_Ads");

        // source change from Profcyma_Google_Ads to DY_Patil_website_traffic by suggestion of saurbah sir on 08/04/26
        // formData.append("source_name", "DY_Patil_website_traffic ");
        formData.append("api_key", "profcyma-new-website");


        // online degree domain and  api key
        // formData.append("api_key", "Profcyma_Google_MBA-WX");



        // edujam domain and  api key
        // formData.append("api_key", "other");
        // formData.append("subdomain", "edujam");


        // https://onlinembainfo.com/ domain and  api key

        // formData.append("api_key", "landing-page");
        // formData.append("subdomain", "bwidesolutions");

        // skillabove domain and  api key
        // formData.append("api_key", "landing-page");
        // formData.append("subdomain", "skillabove");

        // dreammedicine domain and  api key
        // formData.append("api_key", "landing-page");
        // formData.append("subdomain", "dreammedicine");

        // ✅ Add UTM cookies
        formData.append("utm_source", Cookies.get("utm_source") || "");
        formData.append("utm_medium", Cookies.get("utm_medium") || "");
        formData.append("utm_campaign", Cookies.get("utm_campaign") || "");
        formData.append("utm_id", Cookies.get("utm_id") || "");
        formData.append("lpurl", Cookies.get("lpurl") || "");

        formData.forEach((value, key) => {
            console.log(key + ": " + value);
        });

        try {

            const res = await postEnquiryForm(formData);
            if (res?.success) {

                // ✅ Download brochure
                const link = document.createElement("a");
                link.href = "/assets/broucher/dpu_brocher_2027.pdf"; // Path to your brochure in public folder
                link.download = "Brochure.pdf";     // File name for user
                link.click();

                navigate("/thank-you")
            }
            else {
                console.log("res", res)
                toast.error("You've already submitted an inquiry.");
            }

        } catch (error) {
            toast.error("You've already submitted an inquiry.");
        }
    }

    return (

        <>
            <Modal
                className="inquiry-form-modal modal-dialog-scrollable"
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                scrollable
                backdrop="static"
                show={props.show}
                onHide={props.onHide}
            >
                <Modal.Header className="modal-header-centered" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Inquiry Form
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Common_Form />
                </Modal.Body>

                <ToastContainer autoClose={3000} />

            </Modal>
        </>
    );
}

export default Enquiry_Form_Modal;
